import type { NextSteps } from "../api/types";
import { remaining } from "../api/mappers";
import { locale, t } from "../i18n";
import { ruleShort } from "./policies";

/**
 * What comes next to a quiet conversation (decision 0044), as the list and the conversation say
 * it: "retomada hoje às 18:45 · conclui em 31 h sem resposta", and the closing rule that applies.
 */

/** "hoje às 18:45", "amanhã às 09:00", "30/10 às 09:00". */
export function stepWhen(iso: string, now = new Date()): string {
  const at = new Date(iso);
  const time = at.toLocaleTimeString(locale.value, {
    hour: "2-digit",
    minute: "2-digit",
  });
  const day = (d: Date) => d.toDateString();
  if (day(at) === day(now)) return t("inbox.next.today", { time });
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  if (day(at) === day(tomorrow)) return t("inbox.next.tomorrow", { time });
  const date = at.toLocaleDateString(locale.value, {
    day: "2-digit",
    month: "2-digit",
  });
  return t("inbox.next.other_day", { date, time });
}

/** The row's "retomada hoje às 18:45 · conclui em 31 h sem resposta", or null. */
export function nextStepsLine(
  steps: NextSteps | null | undefined,
  now = new Date(),
): string | null {
  if (!steps) return null;
  const parts: string[] = [];
  if (steps.followUp)
    parts.push(
      t("inbox.next.follow_up", { when: stepWhen(steps.followUp.at, now) }),
    );
  const left = steps.closing?.at ? remaining(steps.closing.at, now) : null;
  if (left) parts.push(t("inbox.next.closes", { time: left }));
  return parts.length ? parts.join(" · ") : null;
}

/** "Campanha · Manaus: 48 h sem resposta → a IA escolhe (ou Sem resposta)". */
export function closingRuleText(
  closing: NonNullable<NextSteps["closing"]>,
  outcomeLabel: (code: string) => string,
): string {
  return t("inbox.next.rule_line", {
    whose: `${t(`policy.level.${closing.level}`)} · ${closing.name}`,
    rule: ruleShort(closing, outcomeLabel),
  });
}
